
import Vue, { PropType }  from 'vue'
import { DentalCondition, DentalSurfaceLookup, DentalToothMarkingInfo, DentalToothMarkings, WaitlistTreatment } from '../../../types/Sapphire_dto'

export default Vue.extend({
  name: "dental-top-tooth",
  props: {
    sessionID: Number,
    toothID: Number,          
    patientID: Number,
    waitlistTreatment: Object as PropType<WaitlistTreatment>,
    toothMarkings: Object as PropType<DentalToothMarkings>,
    dentalConditions: Array as () => Array<DentalCondition>,
    clickable: Boolean,
    statusID: Number
  },
  watch: {
    statusID: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.rightInfo.StatusID = this.rightInfo.StatusID > 0  ? newVal : 0;
        this.leftInfo.StatusID= this.leftInfo.StatusID > 0  ? newVal : 0;
        this.topInfo.StatusID = this.topInfo.StatusID > 0  ? newVal : 0;
        this.bottomInfo.StatusID = this.bottomInfo.StatusID > 0  ? newVal : 0;
        this.centerInfo.StatusID = this.centerInfo.StatusID > 0  ? newVal : 0;
      }
    },
  },
  computed: {
    rightInfo(): DentalToothMarkingInfo {
      let temp = this.addNewInfo();
      if (this.toothMarkings) {
            if (this.toothMarkings.RightInfo)
              temp = this.toothMarkings.RightInfo;
      }
      return temp;
    },
    leftInfo(): DentalToothMarkingInfo {
      let temp = this.addNewInfo();
      if (this.toothMarkings) {
            if (this.toothMarkings.LeftInfo)
              temp = this.toothMarkings.LeftInfo;
      }
      return temp;
    },
    topInfo(): DentalToothMarkingInfo {
      let temp = this.addNewInfo();
      if (this.toothMarkings) {
            if (this.toothMarkings.TopInfo)
              temp = this.toothMarkings.TopInfo;
      }
      return temp;
    },
    bottomInfo(): DentalToothMarkingInfo {
      let temp = this.addNewInfo();
      if (this.toothMarkings) {
            if (this.toothMarkings.BottomInfo)
              temp = this.toothMarkings.BottomInfo;
      }
      return temp;
    },
    centerInfo(): DentalToothMarkingInfo {
      let temp = this.addNewInfo();
      if (this.toothMarkings) {
            if (this.toothMarkings.CenterInfo)
              temp = this.toothMarkings.CenterInfo;
      }
      return temp;
    },
    rightConditionClass(): string {
      var t ='';
      if (this.dentalConditions) {
        t = this.dentalConditions.filter(dc => dc.SurfaceLookupList.includes('right')).length > 0 ? 'topToothOutline' : '';
      }
      return t;
    },
    leftConditionClass(): string {
      var t ='';
      if (this.dentalConditions) {
        t = this.dentalConditions.filter(dc => dc.SurfaceLookupList.includes('left')).length > 0 ? 'topToothOutline' : '';
      }
      return t;
    },
    topConditionClass(): string {
      var t ='';
      if (this.dentalConditions) {
        t = this.dentalConditions.filter(dc => dc.SurfaceLookupList.includes('top')).length > 0 ? 'topToothOutline' : '';
      }
      return t;
    },
    bottomConditionClass(): string {
      var t ='';
      if (this.dentalConditions) {
        t = this.dentalConditions.filter(dc => dc.SurfaceLookupList.includes('bottom')).length > 0 ? 'topToothOutline' : '';
      }
      return t;
    },
    centerConditionClass(): string {
      var t ='';
      if (this.dentalConditions) {
        t = this.dentalConditions.filter(dc => dc.SurfaceLookupList.includes('center')).length > 0 ? 'topToothOutline' : '';
      }
      return t;
    },
    rightOnClass(): string {
          return this.getStatusClass(this.rightInfo.StatusID, this.rightInfo.TreatmentName);
    },
    leftOnClass(): string {
      return this.getStatusClass(this.leftInfo.StatusID, this.leftInfo.TreatmentName);
    },
    topOnClass(): string {
      return this.getStatusClass(this.topInfo.StatusID, this.topInfo.TreatmentName);
    },
    bottomOnClass(): string {
      return this.getStatusClass(this.bottomInfo.StatusID, this.bottomInfo.TreatmentName);
    },
    centerOnClass(): string {
        return this.getStatusClass(this.centerInfo.StatusID, this.centerInfo.TreatmentName);
    },
    cnTopToothID(): string{
        return "cnTopToothID" + this.toothID;
    },
    topToothID(): string{
      return "topTooth" + this.toothID;
    },
    isClickable(): string{
        return this.clickable ? '' : 'showDisabled';
    },
  },
  methods: {
    addNewInfo(): DentalToothMarkingInfo {
      let info: DentalToothMarkingInfo = {
        TreatmentName: this.waitlistTreatment ? this.waitlistTreatment.NAME : '',
        SurfaceLookup: DentalSurfaceLookup.Mesial,
        StatusID: 0,
        AssocDate: new Date()
      }
      return info;
    },
    GetBackgroundImage() {
      let style='z-index: 2; height: 46px; width: 46px; display: inline; background: url(../../../Common/Images/dental/center_tooth.png);';
      return style;
    },
    getStatusClass(thisStatusID, thisName) {
      let statusClass = 'topToothOff';
      
      switch (thisStatusID) {
        case 1:
              if (this.toothMarkings.InactiveFlag == true) {
                  statusClass = 'topToothInactive';
              }
              else if (thisName.includes("Resin")) {
                statusClass = 'topToothPreExistingResin';
              }
              else if (thisName.includes("Amal")) {
                  statusClass = 'topToothPreExistingAmal';
              }
              else if (thisName.includes("application")) {
                  statusClass = 'topToothPreExistingApplication';
              }
            else {
                statusClass = 'topToothPreExisting';
            }
          break;
          case 2:
             if (this.toothMarkings.InactiveFlag == true) {
                  statusClass = 'topToothInactive';
              }
              else if (thisName.includes("Resin")) {
                  statusClass = 'topToothWaitlistResin';
              }
              else if (thisName.includes("Amal")) {
                  statusClass = 'topToothWaitlistAmal';
              }
              else if (thisName.includes("application")) {
                  statusClass = 'topToothWaitlistApplication';
              }
              else {
                  statusClass = 'topToothWaitlist';
              }
          
          break;
          case 3:
              
              if (this.toothMarkings.InactiveFlag == true) {
                  statusClass = 'topToothInactive';
              }
              else if (thisName.includes("Resin")) {
                  statusClass = 'topToothProcedureResin';
              }
              else if (thisName.includes("Amal")) {
                  statusClass = 'topToothProcedureAmal';
              }
              else if (thisName.includes("application")) {
                  statusClass = 'topToothProcedureApplication';
              }
              else {
                  statusClass = 'topToothProcedure';
              }
          break;
        default:
          statusClass = 'topToothOff';
        }
      return statusClass;
    },
    toggleClick(buttonName) {
      switch (buttonName) {
        case "right":
          this.rightInfo.StatusID = this.rightInfo.StatusID > 0  ?  0 : this.statusID;
          this.$emit('handle-marking-change', this.rightInfo, 'right');
          break;
        case "left":
          this.leftInfo.StatusID = this.leftInfo.StatusID > 0  ?  0 : this.statusID;
          this.$emit('handle-marking-change', this.leftInfo, 'left');
          break;
        case "top":
          this.topInfo.StatusID  = this.topInfo.StatusID > 0 ?  0 : this.statusID;
          this.$emit('handle-marking-change', this.topInfo, 'top');
          break;
        case "bottom":
          this.bottomInfo.StatusID = this.bottomInfo.StatusID > 0 ?  0 : this.statusID;
          this.$emit('handle-marking-change', this.bottomInfo, 'bottom');
          break;
        case "center":
          this.centerInfo.StatusID = this.centerInfo.StatusID  > 0 ?  0 : this.statusID;
          this.$emit('handle-marking-change', this.centerInfo, 'center');
           break;
      }
      return false;
    },
   
    // async drawCanvasBackground() {
    //   var vm = this;
    //   //var cn = document.getElementById("cnTopToothID" + vm.toothID);
    //   //var ctx = (cn as HTMLCanvasElement).getContext('2d');
    //   const cn = document.getElementById('cnTopToothID' + vm.toothID) as HTMLCanvasElement;
    //   var ctx = cn.getContext('2d');
    //   var img = new Image();
    //   img.id = 'underlyingToothImg' + vm.toothID
    //   img.src = "../../../Common/Images/dental/center_tooth.png";

    //   await img.decode()  
    //   cn.width = img.width;
    //   cn.height = img.height;

    //   ctx.drawImage(img, 0, 0);
      
    // },
   },
});
